import type { ComponentProps } from 'react'
import { LayoutContainer } from '@jana-technology/platform-ui'

type LayoutContainerProps = ComponentProps<typeof LayoutContainer>

const FullWidthLayoutContainer = ({
  className,
  ...props
}: LayoutContainerProps) => {
  const combinedClassName = [className, 'max-w-none']
    .filter(Boolean)
    .join(' ')

  return <LayoutContainer {...props} className={combinedClassName} />
}

export default FullWidthLayoutContainer
